module.exports = __webpack_public_path__ + "static/media/teacher-pointing-blackboard.6b303b35.svg";